import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    content: PropTypes.string.isRequired,
    approveFunc: PropTypes.func,
    title: PropTypes.string,
    approveButtonName: PropTypes.string,
    open: PropTypes.bool,
  },
  getInitialState() {
    return {
      fadeClassName: "modal-view-fade-in",
      isActive: false,
      scrollPos: 0,
    };
  },
  componentDidMount() {
    if (this.props.open) {
      this.openModal();
    }
  },
  openModal() {
    var scrollPos = window.pageYOffset;
    var marginLeft =
      (window.innerWidth - $(".royal_preloader .container").outerWidth()) / 2;
    var width = window.innerWidth > 767 ? "" : "100%";
    $(document.body).css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
      width: width,
    });
    this.setState({
      fadeClassName: "modal-view-fade-in",
      isActive: true,
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $(document.body).css({
      position: "relative",
      marginTop: "0",
      marginLeft: "0",
      width: "",
    });
    $(window).scrollTop(this.state.scrollPos);
    this.setState({
      fadeClassName: "modal-view-fade-out",
    });
    setTimeout(
      function() {
        this.setState({
          isActive: false,
        });
      }.bind(this),
      300
    );
  },
  handleApproveButton() {
    if (this.props.approveFunc != undefined) {
      this.props.approveFunc();
    }
    this.closeModal();
  },
  render() {
    if (!this.state.isActive) {
      return null;
    }
    var header = "";
    if (this.props.title) {
      header = (
        <div
          className="modal-view-header"
          style={{ position: "relative", zIndex: "10001" }}
        >
          <p style={{ margin: "0 15px 6px" }}>
            <strong>{this.props.title}</strong>
          </p>
        </div>
      );
    }
    return (
      <div
        className="modal-view"
        style={{ position: "relative", zIndex: "10001" }}
      >
        <div className={this.state.fadeClassName}>
          <div className="modal-view-overAll">
            <div className="modal-view-overlay" />
            <div className="modal-view-dialog">
              <div className="modal-view-content">
                {header}
                <div className="modal-view-body">
                  {this.props.content.split("\n").map((msg) => {
                    return <p key={msg}>{msg}</p>;
                  })}
                </div>
                <div className="modal-view-footer">
                  <a
                    className="modal-view-button-center-12"
                    onClick={this.handleApproveButton}
                  >
                    {this.props.approveButtonName
                      ? this.props.approveButtonName
                      : "OK"}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
